<template>
  <div v-if="configs">
    <div v-if="configs.code === 500" class="cms-error">
      <span>{{ $t('not_cms') }}</span>
    </div>
    <div v-else class="chart-carousel">
      <carousel
        :per-page="itemsForPage"
        :navigate-to="currentPage"
        @page-change="(n)=>currentPage=n"
      >
        <slide v-for="(chart,i) in filteredCards" :key="i" class="slide">
          <injected-chart
            :key="chart.title"
            :config="chart"
            :visible="(currentPage+1)*itemsForPage>i"
          />
        </slide>
      </carousel>
      <div class="nav-buttons">
        <div class="nav-button prev" :class="{disabled: currentPage===0}" @click="changePage('-')">
          <div class="icon-prev" />
        </div>
        <div class="nav-button next" :class="{disabled: currentPage>=numberOfPages - 1}" @click="changePage('+')">
          <div class="icon-next" />
        </div>
      </div>
    </div>
  </div>
  <div v-else class="loader-wrap">
    <Loader :text="$t('loading')" />
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import InjectedChart from './InjectedChart.vue'
import device from '@/utils/device'
import Loader from '../Loader.vue'
import { getCMSCards } from '@/services/graphql'

export default {
  components: { InjectedChart, Carousel, Slide, Loader },
  props: {
    thesaurusId: String,
  },
  data() {
    return {
      itemsForPage: device === 'mobile' ? 1 : 2,
      currentPage: 0,
    }
  },
  asyncComputed: {
    configs() {
      return getCMSCards(this.$store.state.i18n.lang).then((resp) =>
        {
          if(resp.code === 500) return resp
          else return resp.sort((a, b) => {
            return a.score - b.score
          })
        }
      )
    },
  },
  computed: {
    filteredCards() {
      return this.configs.filter(el => el.category.indexOf(this.thesaurusId) !== -1)
    },
    numberOfPages() {
      return Math.ceil(this.filteredCards.length / this.itemsForPage)
    },
  },
  watch: {
    thesaurusId() {
      this.currentPage = 0
    }
  },
  methods: {
    changePage(key) {
      if (key === '+' && this.currentPage !== this.numberOfPages - 1) this.currentPage += 1
      else if (key === '-' && this.currentPage !== 0) this.currentPage -= 1
    },
  }
}
</script>

<style lang="stylus" scoped>
.chart-carousel
  display: flex
  flex-direction: column
  gap: vw(20px)

  .VueCarousel

    >>> .VueCarousel-dot-container
      display: flex
      gap: 20px

    >>> .VueCarousel-dot
      border: 1px solid $grey-dark
      padding: 0px !important
    >>> .VueCarousel-inner
      margin-right: vw(-10px)
      margin-left: vw(-10px)

    .slide
      $percentage = percentage((1 / 2))
      $gap = vw(20px)
      $width = "calc(%s - %s)" % ($percentage $gap)
      display: flex
      flex: 0 0 $width
      overflow: hidden
      margin-right: vw(10px)
      margin-left: vw(10px)
      height: 300px

      .mobile &
        $percentage = percentage((1 / 1))
        $gap = vw(20px)
        $width = "calc(%s - %s)" % ($percentage $gap)
        flex: 0 0 $width

      .injected-chart
        overflow: visible
        >>> .el
          overflow: visible !important

    >>> .VueCarousel-pagination
      display: none

      .mobile &
        display: flex
        margin-bottom: vw(30px)

  .nav-buttons
    display: flex
    justify-content: space-between

    .mobile &
      display: none

    .nav-button
      cursor: pointer

      &.disabled
        opacity: 0.3

      .icon-prev
        m-icon("download-black-fill", 40, #fff, false)
        transform: rotate(90deg)

      .icon-next
        m-icon("download-black-fill", 40, #fff, false)
        transform: rotate(-90deg)

.cms-error
  display: flex
  justify-content: center
  margin-top: vw(10px)
  padding-bottom: vw(35px)
  width: 100%

  span
    m-font-size(20, 26)
    color: black
    font-weight: 400

.loader-wrap
  position: relative
  width: 100%
  height: 110px
</style>
